import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Box, Chip, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { blogPosts } from '../data/blogPosts';
import WhatsAppButton from '../components/WhatsAppButton';
import { typographyStyles } from '../styles/commonStyles';

export default function Energies() {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = React.useState(i18n.language);

  const handleLanguageChange = (event, newLanguage) => {
    if (newLanguage !== null) {
      setLanguage(newLanguage);
      i18n.changeLanguage(newLanguage);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 8, mb: 8 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Typography
          component="h1"
          variant="h2"
          align="center"
          gutterBottom
          sx={{ ...typographyStyles.sectionTitle, mb: 3, color: '#4A4A4A' }}
        >
          {t('energies.title')}
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
          <ToggleButtonGroup
            value={language}
            exclusive
            onChange={handleLanguageChange}
            aria-label="language"
            sx={{
              '& .MuiToggleButton-root': {
                color: '#4A4A4A',
                '&.Mui-selected': {
                  background: 'linear-gradient(45deg, #EC24227, #EA5A28)',
                  color: 'white',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #EA5A28, #EC24227)',
                  }
                }
              }
            }}
          >
            <ToggleButton value="es" aria-label="spanish">
              Español
            </ToggleButton>
            <ToggleButton value="en" aria-label="english">
              English
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </motion.div>

      <Grid container spacing={4}>
        {blogPosts.map((post, index) => (
          <Grid item xs={12} key={post.id}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              <Card
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  background: 'rgba(255, 255, 255, 0.9)',
                  backdropFilter: 'blur(10px)',
                  boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
                  borderRadius: '10px',
                  border: '1px solid rgba(255, 255, 255, 0.18)',
                  overflow: 'hidden'
                }}
              >
                <CardMedia
                  component="img"
                  sx={{
                    width: { xs: '100%', md: '40%' },
                    height: { xs: 240, md: 'auto' },
                    objectFit: 'cover'
                  }}
                  image={post.image}
                  alt={post.title[language]}
                />
                <CardContent sx={{ flex: 1, p: 4 }}>
                  <Typography
                    variant="h4"
                    component="h2"
                    gutterBottom
                    sx={{ ...typographyStyles.smallTitle, color: '#4A4A4A', mb: 2 }}
                  >
                    {post.title[language]}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    gutterBottom
                    sx={{ mb: 2 }}
                  >
                    {post.date} | {post.author}
                  </Typography>
                  <Typography
                    variant="body1"
                    paragraph
                    sx={{ ...typographyStyles.bodyText, whiteSpace: 'pre-line' }}
                  >
                    {post.content[language]}
                  </Typography>
                  <Box sx={{ mt: 3, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    {post.tags[language].map((tag) => (
                      <Chip
                        key={tag}
                        label={tag}
                        sx={{
                          background: 'linear-gradient(45deg, #EC24227, #EA5A28)',
                          color: 'black',
                          '&:hover': {
                            background: 'linear-gradient(45deg, #EA5A28, #EC24227)',
                          }
                        }}
                      />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
       {/* WhatsApp Button */}
       <WhatsAppButton />
    </Container>
  );
}
